import React, { useEffect, useState } from "react";
import logo from "../assets/icons/black full logo.svg";
import { useRedirect } from "../hooks/useRedirect";
import pathnames from "../routes/index.route";
import { useLocation } from "react-router-dom";
import user from "../assets/images/user.png";
import video from "../assets/images/Rectangle 18156.png";
import { AngleDotIcon, ArrowDownIcon, ArrowUpIcon, FolderIcon, HomeIcon, ScheduleCalendarIcon, SettingIcon, SupportIcon } from "../assets/icons/Icons";

const Sidebar = () => {
  const redirect = useRedirect();
  const { pathname } = useLocation();
  const [showGroup, setShowGroup] = useState<boolean>(false);
  const [showFiles, setShowFiles] = useState<boolean>(false);

  // function getFirstPath(path: string) {
  //   const parts = path.split('/');
  //   return `/${parts[1]}`;
  // }
  function getSecPath(path: string) {
    const parts = path.split('/');
    return `/${parts[2]}`;
  }
  const handleShowGroup = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    setShowGroup(prev => !prev);
  }
  const handleShowFiles = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    setShowFiles(prev => !prev);
  }
  useEffect(() => {
    if (getSecPath(pathname) === pathnames.specificGroup) {
      setShowGroup(true);
    }
    if (getSecPath(pathname) === pathnames.specificFileGroup) {
      setShowFiles(true);
    }
  }, [pathname])
  return (
    <div className="w-[230px] max-h-screen overflow-y-auto overflow-x-hidden bg-white m-2 rounded-2xl thin-scrollbar">
      <div className="flex flex-col items-center h-full">
        <div className="w-[230px] flex flex-col justify-between h-full">
          <div>
            <img
              onClick={() => redirect(pathnames.home)}
              className="w-[117.8px] mt-4 ml-4 mb-[13px] cursor-pointer" src={logo} alt="logo"
            />
            <hr />
            <div className="p-2 mt-2">
              <h1 className="text-zinc-400 text-xs font-medium tracking-tight px-2 mb-2">General</h1>
              <div onClick={() => redirect(pathnames.home)} className={`flex items-center gap-2 ${pathname === pathnames.home && "bg-[#EAE9EF]"} p-2 rounded-lg mb-[1px] cursor-pointer`}>
                <HomeIcon fill={pathname === pathnames.home ? "#0F0C18" : "#9392A2"} />
                <p className={`${pathname === pathnames.home ? "text-[#0F0C18]" : "text-[#9392A2]"} text-sm font-semibold leading-[14px] tracking-tight`}>Dashboard</p>
              </div>
              <div onClick={() => redirect(pathnames.accounts)} className={`flex items-center justify-between p-2 ${pathname === pathnames.accounts && "bg-[#EAE9EF]"} rounded-lg mb-[1px] cursor-pointer`}>
                <div className="flex items-center gap-2">
                  <AngleDotIcon fill={(pathname === pathnames.accounts) || (getSecPath(pathname) === pathnames.specificGroup) || (getSecPath(pathname) === pathnames.specificAccount) ? "#0F0C18" : "#9392A2"} />
                  <p className={`${(pathname === pathnames.accounts) || (getSecPath(pathname) === pathnames.specificGroup) || (getSecPath(pathname) === pathnames.specificAccount) ? "text-[#0F0C18]" : "text-[#9392A2]"} text-sm font-semibold tracking-tight`}>SMA - Groups</p>
                </div>
                <div onClick={handleShowGroup} className="flex items-center gap-[6px]">
                  <p className={`text-[#9392A2] text-sm font-semibold leading-[14px] tracking-tight`}>6</p>
                  {
                    showGroup ?
                      <ArrowUpIcon /> :
                      <ArrowDownIcon />
                  }
                </div>
              </div>
              {/* All group of accounts */}
              {
                showGroup &&
                <div>
                  {
                    [...Array(2)].map((_, index) => (
                      <div key={index} onClick={() => redirect(pathnames.accounts + pathnames.specificGroup)} className={`flex items-center gap-3 p-2 px-3 rounded-lg mb-[1px] ${((getSecPath(pathname) === pathnames.specificGroup) || (getSecPath(pathname) === pathnames.specificAccount)) && "bg-[#EAE9EF]"} cursor-pointer animate-zoomIn`}>
                        <img src={user} className="w-4 h-4 rounded-full" alt="user" />
                        <p className={`${(getSecPath(pathname) === pathnames.specificGroup) || (getSecPath(pathname) === pathnames.specificAccount) ? "text-[#0F0C18]" : "text-[#9392A2]"} text-xs font-medium tracking-tight`}>Andrew Wack</p>
                      </div>
                    ))
                  }
                </div>
              }
              <div onClick={() => redirect(pathnames.content)} className={`flex items-center justify-between p-2 ${pathname === pathnames.content && "bg-[#EAE9EF]"} rounded-lg mb-[1px] cursor-pointer`}>
                <div className="flex items-center gap-2">
                  <FolderIcon fill={(pathname === pathnames.content || getSecPath(pathname) === pathnames.specificFileGroup) ? "#0F0C18" : "#9392A2"} />
                  <p className={`${(pathname === pathnames.content || getSecPath(pathname) === pathnames.specificFileGroup) ? "text-[#0F0C18]" : "text-[#9392A2]"} text-sm font-semibold leading-[14px] tracking-tight`}>Content</p>
                </div>
                <div onClick={handleShowFiles} className="flex items-center gap-[6px]">
                  <p className="text-[#9392A2] text-sm font-semibold leading-[14px] tracking-tight">726</p>
                  {
                    showFiles ?
                      <ArrowUpIcon /> :
                      <ArrowDownIcon />
                  }
                </div>
              </div>
              {/* All file */}
              {
                showFiles &&
                <div>
                  {
                    [...Array(2)].map((_, index) => (
                      <div key={index} onClick={() => redirect(pathnames.content + pathnames.specificFileGroup)} className={`flex items-center gap-3 p-2 px-2.5 ${(getSecPath(pathname) === pathnames.specificFileGroup) && "bg-[#EAE9EF]"} rounded-lg mb-[1px] cursor-pointer animate-zoomIn`}>
                        <img src={video} className="w-4 h-4 rounded-sm" alt="user" />
                        <p className={`text-xs font-medium ${(getSecPath(pathname) === pathnames.specificFileGroup) ? "bg-[#EAE9EF]" : "text-[#9392A2]"} tracking-tight`}>Game video</p>
                      </div>
                    ))
                  }
                </div>
              }
              <div onClick={() => redirect(pathnames.scheduledPost)} className={`flex items-center gap-2 ${pathname === pathnames.scheduledPost && "bg-[#EAE9EF]"} p-2 rounded-lg mb-[1px] cursor-pointer`}>
                <ScheduleCalendarIcon stroke={pathname === pathnames.scheduledPost ? "#0F0C18" : "#9392A2"} />
                <p className={`${pathname === pathnames.scheduledPost ? "text-[#0F0C18]" : "text-[#9392A2]"} text-sm font-semibold leading-[14px] tracking-tight`}>Schedules</p>
              </div>

              <h1 className="text-zinc-400 text-xs font-medium tracking-tight px-2 mb-2 mt-8">Other</h1>
              <div onClick={() => redirect(pathnames.settings)} className={`flex items-center gap-2 p-2 rounded-lg mb-[1px] cursor-pointer ${pathname === pathnames.settings && "bg-[#EAE9EF]"}`}>
                <SettingIcon fill={pathname === pathnames.settings ? "#0F0C18" : "#9392A2"} />
                <p className={`${pathname === pathnames.settings ? "text-[#0F0C18]" : "text-[#9392A2]"} text-sm font-semibold leading-[14px] tracking-tight`}>Settings</p>
              </div>
              <div className="flex items-center gap-2 p-2 rounded-lg mb-[1px] cursor-pointer">
                <SupportIcon />
                <p className="text-[#9392A2] text-sm font-semibold leading-[14px] tracking-tight">Support</p>
              </div>
            </div>
          </div>
          <div className="w-[230px]">
            {/* <div className="flex flex-col items-center cursor-pointer gap-1 border border-[#EAE9EF] mx-4 mb-3 py-3 rounded-xl">
              <UploadIcon />
              <p className="text-center text-[#9392A2] text-xs font-medium leading-[14.40px] tracking-tight">Upload video or voice a file</p>
            </div> */}
            <hr />
            <div className="p-4">
              <p className="text-[#9392A2] text-xs font-medium leading-[18px] tracking-tight">© Dubmate</p>
              <div className="flex items-center justify-between">
                <p className="text-[#9392A2] text-xs font-medium leading-[18px] tracking-tight">Version 1.1.2</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
